
export class Scene3 extends Phaser.Scene {

  constructor() {
    super({
        key: "Scene3"
    });
  }

    preload(): void {
        this.load.image("ooze", require("/src/assets/phaser-assets/textures/ooze.png"));

  }

    create(): void {
        let im = this.add.image(200, 250, "ooze");
        im.setOrigin(0);
        im.setDisplaySize(400, 400);

  }

  update(): void {
   
  }

}



// WEBPACK FOOTER //
// ./src/games/demos/phaserMultiSceneDemo/scenes/scene3.ts